import { NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { AvailableLangs, TranslocoService } from '@ngneat/transloco';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'languages',
    templateUrl: './languages.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'languages',
    standalone: true,
    imports: [MatButtonModule, MatMenuModule, NgTemplateOutlet],
})
export class LanguagesComponent implements OnInit, OnDestroy {
    availableLangs: AvailableLangs;
    activeLang: string;
    flagCodes: any;

    constructor(private _translocoService: TranslocoService, private _changeDetectorRef : ChangeDetectorRef) {}

    ngOnInit(): void {
        this.availableLangs = this._translocoService.getAvailableLangs();

        const savedLang =
            localStorage.getItem('selectedLang') ||
            this._translocoService.getDefaultLang();
        this.setActiveLang(savedLang);
    
        this._translocoService.langChanges$.subscribe((activeLang) => {
            this.activeLang = activeLang;
            this._changeDetectorRef.markForCheck();
        });
    
        this.flagCodes = {
            en: 'us',
            sq: 'sq',
            es: 'es',
            pt: 'pt',
            tr: 'tr',
        };
    }    

    ngOnDestroy(): void {}

    setActiveLang(lang: string): void {
        if (lang !== this.activeLang) {
            lastValueFrom(this._translocoService.load(lang))
                .then(() => {
                    this._translocoService.setActiveLang(lang);
                    localStorage.setItem('selectedLang', lang);
                })
                .catch((error) => {
                    console.error(`Failed to load language ${lang}:`, error);
                });
        }
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    // private _updateNavigation(lang: string): void {
    //     const navComponent =
    //         this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
    //             'mainNavigation'
    //         );

    //     if (!navComponent) {
    //         return null;
    //     }

    //     const navigation = navComponent.navigation;

    //     const projectDashboardItem = this._fuseNavigationService.getItem(
    //         'dashboards.project',
    //         navigation
    //     );
    //     if (projectDashboardItem) {
    //         this._translocoService
    //             .selectTranslate('Project')
    //             .pipe(take(1))
    //             .subscribe((translation) => {
    //                 projectDashboardItem.title = translation;
    //                 navComponent.refresh();
    //             });
    //     }

    //     const analyticsDashboardItem = this._fuseNavigationService.getItem(
    //         'dashboards.analytics',
    //         navigation
    //     );
    //     if (analyticsDashboardItem) {
    //         this._translocoService
    //             .selectTranslate('Analytics')
    //             .pipe(take(1))
    //             .subscribe((translation) => {
    //                 analyticsDashboardItem.title = translation;
    //                 navComponent.refresh();
    //             });
    //     }
    // }
}
